module.exports = __webpack_public_path__ + "96dac983dd2f3c7cc09c62f2bcc0bae9.svg";